var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from "classnames";
import * as React from "react";
import loadSprite from "./loadSprite";
export default class Icon extends React.Component {
    componentDidMount() {
        // loadSprite()
    }
    render() {
        const _a = this.props, { type, className } = _a, restProps = __rest(_a, ["type", "className"]);
        const cls = classnames(className, "pm-icon", `pm-icon-${type}`);
        return (<svg className={cls} {...restProps}>
        <use xlinkHref={`#${type}`}/>
      </svg>);
    }
}
Icon.LoadSprite = loadSprite;
